import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import _ from 'lodash';
import { useSpring, animated } from 'react-spring';
import { colorVars, colorLongToShort, lightenColor, getCssColorFromColorName, INHERIT, } from '../../../utils/colors';
import classnames from 'classnames/bind';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const COLOR_NAMES = _.keys(colorVars).map(colorLongToShort);
const COLOR_OPTIONS = COLOR_NAMES.concat(INHERIT, '');
const AnimatedProgressBar = ({ className, elmId, color: colorName, percent, animationSeconds = 0.6, height = 10, rounded = false, }) => {
    const backgroundColor = getCssColorFromColorName(colorName);
    const pinstripeColor = lightenColor(backgroundColor, 50);
    const [barStyles, setBarStyles] = useSpring(() => ({
        from: { width: '0%' },
        to: { width: `${percent}%` },
        config: { duration: animationSeconds * 1000 },
    }));
    useEffect(() => {
        setBarStyles({
            to: { width: `${percent}%` },
            config: { duration: animationSeconds * 1000 },
        });
    }, [percent, animationSeconds, barStyles, setBarStyles]);
    return (_jsx("div", { className: cx('bar', { rounded }, className), "data-elm-id": elmId, style: { height }, children: _jsx(animated.div, { style: {
                backgroundColor,
                ...barStyles,
                height: '100%',
            }, className: cx('bar-inner'), children: rounded && (_jsx("div", { style: {
                    backgroundColor: pinstripeColor,
                    height: '20%',
                    left: 0.4 * height,
                    right: 0.4 * height,
                }, className: cx('pinstripe') })) }) }));
};
export default AnimatedProgressBar;
//# sourceMappingURL=index.js.map